(function () {
  const widgets = document.querySelectorAll("[data-br-review-count]");
  if (!widgets.length) return;

  const escapeHtml = (value) =>
    String(value == null ? "" : value).replace(/[&<>"']/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    })[char]);

  const stars = (rating) => {
    const rounded = Math.round(Number(rating || 0));
    return "★★★★★".slice(0, rounded) + "☆☆☆☆☆".slice(0, 5 - rounded);
  };

  const fetchJson = async (baseUrl, path, params) => {
    const response = await fetch(`${baseUrl}${path}?${params.toString()}`, { credentials: "omit" });
    if (!response.ok) throw new Error(`Review count request failed: ${response.status}`);
    return response.json();
  };

  const paramsFor = (widget) => {
    const params = new URLSearchParams({
      shop: widget.dataset.shop || "",
      limit: "1"
    });
    if (widget.dataset.productId) params.set("product_id", widget.dataset.productId);
    if (widget.dataset.handle) params.set("handle", widget.dataset.handle);
    return params;
  };

  const formatText = (widget, rating, count) => {
    const template = widget.dataset.textTemplate || "{count} reviews";
    return template
      .replace(/\{count\}/gi, String(count))
      .replace(/\{rating\}/gi, rating.toFixed(1))
      .replace(/\{product\}/gi, widget.dataset.productTitle || "this product");
  };

  const render = async (widget) => {
    if (widget.dataset.rendered === "true") return;
    widget.dataset.rendered = "true";

    const baseUrl = (widget.dataset.apiBase || "").replace(/\/$/, "");
    if (!baseUrl || !widget.dataset.shop) return;

    const summary = await fetchJson(baseUrl, "/api/storefront/summary", paramsFor(widget));
    const count = Number(summary.review_count || 0);
    const rating = Number(summary.rating_value || 0);
    if (!count || !rating) return;

    const text = formatText(widget, rating, count);
    const showStars = widget.dataset.showStars === "true";
    const showRating = widget.dataset.showRating === "true";

    widget.innerHTML = `
      <span class="br-review-count__inner" aria-label="${escapeHtml(rating.toFixed(1))} out of 5 based on ${escapeHtml(String(count))} ${count === 1 ? "review" : "reviews"}">
        ${showStars ? `<span class="br-review-count__stars" aria-hidden="true">${stars(rating)}</span>` : ""}
        ${showRating ? `<strong class="br-review-count__rating">${rating.toFixed(1)}</strong>` : ""}
        <span class="br-review-count__text">${escapeHtml(text)}</span>
      </span>
    `;
    widget.hidden = false;
  };

  widgets.forEach((widget) => {
    render(widget).catch(() => {
      widget.hidden = true;
    });
  });
})();
